export default __webpack_public_path__ + "static/media/Moreira.27702601.jpeg";